import { Core } from "@faire/design-tokens";
import { getBrandToken } from "@faire/help-center-utils/serialized-data/getBrand";
import { getRetailerToken } from "@faire/help-center-utils/serialized-data/getRetailer";
import { Button } from "@faire/web--source/slate/Button";
import { Chevron } from "@faire/web--source/slate/icons/foundation/Chevron";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { trackHelpCenterSelfServeBackClick } from "@faire/web-api--source/events/helpCenter/click/selfServeBack";
import React from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";

import { useIssueType } from "../hooks/useIssueType";
import { useNavigation } from "../hooks/useNavigation";

export const BackButton: React.FC = () => {
  const { goToPreviousStep } = useNavigation();
  const { isMobile } = useViewport();
  const history = useHistory();
  const retailerToken = getRetailerToken() ?? "";
  const brandToken = getBrandToken() ?? "";
  const { issueType } = useIssueType();

  const handleBackButtonClick = () => {
    trackHelpCenterSelfServeBackClick(
      retailerToken,
      brandToken,
      history.location.pathname,
      issueType
    );
    goToPreviousStep();
  };

  if (isMobile) {
    return null;
  }

  return (
    <GoBackCTA variant="tertiary" onClick={handleBackButtonClick}>
      <LeftChevron fontSize="10" direction="left" />
      <Spacer width="1x" />
      <Typography variant="paragraphSansRegular">
        <StrictLocalMsg
          defaultMessage="Back"
          description={{
            text: "Link to take the user back to the previous step in the self-serve experience",
          }}
        />
      </Typography>
    </GoBackCTA>
  );
};

const GoBackCTA = styled(Button)``;

const LeftChevron = styled(Chevron)`
  color: ${Core.icon.default};
`;
